export const isValidClinicTel = value => {
  // 数字とハイフンのみ
  // 数字の合計が10~11個
  // ハイフンが0~2個
  // 先頭と末尾にはハイフンがつかない
  // 連続したハイフンがない
  const digitCount = value.replace(/-/g, '').length
  return (
    /^[\d-]+$/.test(value) &&
    (digitCount === 10 || digitCount === 11) &&
    value.replace(/\d/g, '').length < 3 &&
    /^\d.*\d$/.test(value) &&
    !value.includes('--')
  )
}
